class NewDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector("#NavDrawer")
    this.mother_list = this.querySelector(".nav-drawer__links")
    this.body = document.querySelector("body")
    this.mother_btns = this.querySelectorAll(".mobile-nav__toggle-btn")
    this.mother_links = this.querySelectorAll(".mobile-nav__item")
    this.mother_btns.forEach( (motherButton) => { motherButton.addEventListener('click', () => this.motherList() ) })
    this.mother_links.forEach( (motherLink) => { motherLink.addEventListener('click', (e) => this.subList(e) ) })
    this.initAccordions()


  }
  motherList() {
    this.body.classList.remove("js-nav-expanded")
  }
  subList(e) {
    if (e.target.closest(".mobile-nav__item").getAttribute("aria-haspopup")) {
      this.mother_links.forEach((motherLink) => { motherLink.classList.remove("mobile-nav--expanded") })
      e.target.closest(".mobile-nav__item").classList.add("mobile-nav--expanded")
    } else if (e.target.closest(".mobile-nav__item").classList.contains('mobile-nav__item--accordion')) {

    } else {
      location.href = e.target.getAttribute('href')
    }

  }

  initAccordions() {
    const accordions = document.querySelectorAll('.accordions');

    accordions.forEach(accordion => {
      if (accordion.disabled) return;

      const triggers = accordion.querySelectorAll('.accordion__trigger');
      const panels = accordion.querySelectorAll('.accordion__panel');

      const handleClick = event => {
        // find the current trigger
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()

        const trigger = event.target;
        
        if (trigger.matches('.accordion__link')) {
          window.location = trigger.getAttribute("href");
          return;
        } else if (trigger.matches('.accordion__link_blank')) {
          window.open(trigger.parentNode.getAttribute("href"), '_blank').focus();
          return;
        }
        if (!trigger.matches('.accordion__trigger')) return;
        
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // if we haven't clicked on a trigger return
        if (!trigger) {
          return;
        }

        // find the current panel
        const panelId = trigger.getAttribute('aria-controls');
        const panel = accordion.querySelector(`#${panelId}`);

        // hide all panels
        // triggers.forEach(trigger => trigger.setAttribute('aria-expanded', false));
        // panels.forEach(panel => panel.setAttribute('hidden', true));

        if (!isExpanded) {
          // show the current panel
          trigger.setAttribute('aria-expanded', true);
          panel.removeAttribute('hidden');
        } else {
          trigger.setAttribute('aria-expanded', false);
          panel.setAttribute('hidden', true);
        }

        const isMobileNavAccordion = trigger.classList.contains('nav-accordion__trigger');
        if (isMobileNavAccordion) {
          document.dispatchEvent(new Event('navAccordionClick'));
        }
      };

      // attach event listener to the accordion itself
      accordion.addEventListener('click', handleClick);
    });

    // Some elements become accordions only on mobile;
    // This checks for elements with accordion--medium-down class
    // and if on mobile it add attributes to trigger and panel elements so the accordion functionality works
    const accordionsMobile = document.querySelectorAll('.accordion--large-down');

    if (accordionsMobile.length === 0) return;

    const addAccordionAttr = elem => {
      elem.querySelector('.accordion__panel').setAttribute('hidden', true);
      elem.querySelector('.accordion__trigger').removeAttribute('disabled');
      elem.querySelector('.accordion__trigger').setAttribute('aria-expanded', false);
    };

    const removeAccordionAttr = elem => {
      elem.querySelector('.accordion__panel').removeAttribute('hidden');
      elem.querySelector('.accordion__trigger').disabled = true;
      elem.querySelector('.accordion__trigger').removeAttribute('aria-expanded');
    };

    const handleResize = e => {
      if (e.matches) {
        accordionsMobile.forEach(accordion => {
          addAccordionAttr(accordion);
        });
      } else {
        accordionsMobile.forEach(accordion => {
          removeAccordionAttr(accordion);
        });
      }
    };

    const mobileQuery = window.matchMedia(`(max-width: 768px)`);

    if (mobileQuery.matches) {
      accordionsMobile.forEach(accordion => {
        addAccordionAttr(accordion);
      });
    }

    mobileQuery.addListener(e => {
      handleResize(e);
    });
  };


}
customElements.define('new-drawer', NewDrawer);
